/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import { motion } from 'framer-motion';
// Material UI components
import CircularProgress from '@mui/material/CircularProgress';
// Custom components
import ContentListItem from '../../../shared-components/crud/listing/ContentListItem';
import EmptyListing from '../../../shared-components/crud/listing/EmptyListing';

function InstanceList(props) {
  const { listing, resource } = props;
  // if there are no lessons passed, return null
  if (!listing) {
    return <CircularProgress />;
  }

  if (listing.length === 0) {
    return <EmptyListing resource={resource} />;
  }

  const handleGridClasses = () => {
    switch (resource) {
      case 'courses':
        return 'w-full max-h-full m-0 p-0 flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-32 ';
      case 'pages':
        return 'w-full m-0 p-0 flex grid grid-cols-1 gap-32';
      default:
        return 'w-full m-0 p-0 flex grid grid-cols-1 md:grid-cols-2 gap-32';
    }
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
      <div className={handleGridClasses()}>
        {listing.map((instance, index) => (
          <ContentListItem key={index} instance={instance} resource={resource} />
        ))}
      </div>
    </motion.div>
  );
}

export default InstanceList;
